import type { ReactNode } from 'react';

import type { IconComponent } from '@motorway/mw-highway-code';

import styles from './HeadingWithIcon.scss';

export const HeadingWithIcon = ({ description, heading, icon, level: Level = 'h2' }: {
    description?: ReactNode;
    heading: ReactNode;
    icon: IconComponent;
    level?: 'h1' | 'h2' | 'h3' | 'h4';
}) => <div className={styles.component}>
  {icon}
  <div className={styles.content}>
    <Level className={styles.heading}>{heading}</Level>
    {description && <p data-thc-style-override className={styles.description}>{description}</p>}
  </div>
</div>;
